<template>
  <v-row>
    <DlgConfirmCancel ref="confirm"></DlgConfirmCancel>
    <v-col cols="12">
      <v-row justify="end" class="mt-1">
        <v-col cols="2">
          <v-select
            dense
            outlined
            v-model="productId"
            :items="products"
            item-text="description"
            item-value="id"
            label="Plano"
            :clearable="true"
            :loading="!products"
            @change="loadItems"
          ></v-select>
        </v-col>
      </v-row>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalElements"
        :loading="isSearching"
        item-key="id"
        locale="pt-BR"
        show-select
        class="elevation-3"
      >
        <template v-slot:item.copay="{item}">
          <v-row justify="center" class="mt-1 mb-1">
            <v-col cols="12">
              <v-select :items="coparticipationValues" return-object item-value="id" item-text="description" v-model="item.copayType"
                        label="Tipo de Coparticipação" outlined dense hide-details="true" style="width: 200px" @change="updateShareModelPlanCopay(item)"
              ></v-select>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.description  ="{ item }">
          <share-model-descriptions
            :item="item"
            :share-model-descriptions="getShareModelDescriptions"
            @on-description-created="updateShareModelPlan"
            class="mt-1 mb-1"
          >
          </share-model-descriptions>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import ShareModelPlanService from "@/services/insurancepricing/ShareModelPlanService";
import ShareModelDescriptions from "@/view/share_model/share_model_descriptions";
import {mapActions, mapGetters, mapMutations} from "vuex";
import DlgConfirmCancel from '@/components/dlg-confirm_cancel.vue';

export default {
  components: {ShareModelDescriptions, DlgConfirmCancel},
  props: {
    shareModelId: {
      type: String,
    },
  },
  data() {
    return {
      headers: [
        { text: "Operadora", value: "plan.carrierName" },
        { text: "Código", value: "plan.productCode" },
        { text: "Plano", value: "plan.description" },
        {text: 'Tipo de Coparticipação', value: 'copay', width: '20%'},
        { text: "Descrição", value: "description", sortable: false },
      ],
      coparticipationValues: ["10% de Coparticipação","20% de Coparticipação","30% de Coparticipação","40% de Coparticipação","50% de Coparticipação", "Sem Coparticipação", "Fixo"],
      isSearching: false,
      options: {},
      items: [],
      totalElements: null,
      singleSelect: false,
      selected: [],
      products: null,
      productId: null
    };
  },
  
  async created() {
    this._shareModelPlanService = new ShareModelPlanService();
  },

  watch: {
    options: {
      async handler() {
        await this.loadData();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("shareModel", ["getShareModelDescriptions"]),
  },
  methods: {
    ...mapActions("shareModel", ["fetchShareModelDescriptions"]),
    ...mapMutations(["toogleDialogLoading", "showmsg"]),

    async updateShareModelPlan(shareModelPlan, shareModelDescriptionId) {
      const bodyFormData = new FormData();
      bodyFormData.append('shareModelDescriptionId', shareModelDescriptionId)
      await this._shareModelPlanService.update(this.shareModelId, shareModelPlan.id, bodyFormData);
    },
    async updateShareModelPlanCopay(shareModelPlan) {
      const bodyFormData = new FormData();
      bodyFormData.append('copayType', shareModelPlan.copayType);
      await this._shareModelPlanService.updateCopay(
        this.shareModelId,
        shareModelPlan.id,
        bodyFormData,
      );
    },

    async loadData() {
      await this.loadItems();
      await this.loadProducts();
    },

    async loadItems() {
      this.isSearching = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let res = await this._shareModelPlanService.findAllByShareModelId(
        this.shareModelId,
        {
          page: page ? page - 1 : 0,
          sortBy:
            sortBy && sortBy.length
              ? sortBy[0] === "plan.carrierName"
                ? "plan.productFamily.carrier.name"
                : sortBy[0]
              : "plan.productCode",
          descending: sortDesc && sortDesc.length ? sortDesc[0] : false,
          size: itemsPerPage,
          planId: this.productId
        }
      );
      this.items = res.data.content;
      this.totalElements = res.data.totalElements;
      this.isSearching = false;
      this.$emit("on-load");
      
      
      if (!this.getShareModelDescriptions.length) {
        this.fetchShareModelDescriptions(this.shareModelId);
      }
    },

    async loadProducts() {
      this.products = null;
      const {page, itemsPerPage} = this.options;
      let res = await this._shareModelPlanService.findAllByShareModelId(
        this.shareModelId,
        {
          page: page,
          sortBy: "plan.description",
          descending: false,
          size: itemsPerPage
        }
      )
      this.products = res.data.content.map((item) => item.plan);
      this.totalElements = res.data.totalElements;
    },

    async removeAll() {
      if (
        this.selected.length &&
        await this.$refs.confirm.show('Atenção', "Deseja excluir os registros selecionados?")
      ) {
        this.toogleDialogLoading(true);
        try {
          for (const shareModelPlan of this.selected) {
            await this._shareModelPlanService.delete(
              this.shareModelId,
              shareModelPlan.id
            );
          }
          this.showmsg({ text: "Planos desassociados com sucesso!" });
        } catch (error) {
          this.showmsg({ text: "Erro ao desassociaar Planos!" });
        }
        
        this.toogleDialogLoading(false);
        await this.loadData();
      }
    },
  },
};
</script>
